// extracted by mini-css-extract-plugin
export default {"clickingOverviewContainer":"Medications_clickingOverviewContainer__6ZE-o","chartHeader":"Medications_chartHeader__vkTSX"};